module.exports = __webpack_public_path__ + "static/media/EmploymentLabour.6be8bf50.jpg";